import { useEffect, useState } from 'react';
import './Preloader.scss';

interface PreloaderProps {
  isSceneLoaded: boolean;
  onFinish: () => void;
  isTransition?: boolean;
}

export const Preloader = ({ isSceneLoaded, onFinish, isTransition = false }: PreloaderProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);
  const [isAppearing, setIsAppearing] = useState(true);

  useEffect(() => {
    if (isTransition) {
      // Даем время для рендера с opacity: 0
      requestAnimationFrame(() => {
        setIsAppearing(false);
      });
    }

    if (isSceneLoaded) {
      setIsFading(true);
      setTimeout(() => {
        setIsVisible(false);
        onFinish();
      }, 500);
    }
  }, [isSceneLoaded, onFinish, isTransition]);

  if (!isVisible) return null;

  return (
    <div className={`preloader ${isTransition ? 'transition' : ''} ${isAppearing ? 'appearing' : ''} ${isFading ? 'fade-out' : ''}`}>
      <ul role="progressbar" aria-busy="true" aria-label="Loading domino shop">
        <li role="presentation"></li>
        <li role="presentation"></li>
        <li role="presentation"></li>
        <li role="presentation"></li>
        <li role="presentation"></li>
        <li role="presentation"></li>
        <li role="presentation"></li>
      </ul>
      <span className="loading-text">The Museum of Digital Influence</span>
    </div>
  );
};